export default __webpack_public_path__ + "static/media/lorenzYZ.a821da43.svg";